import "./header-section.css";

const HeaderSection = ({ name, icon, width }) => {
  return (
    <div
      className="m-b-5 flex-nowrap align-items-center d-flex"
      style={{
        gap: "5px",
        width: width ? `${width}px` : "auto",
        minWidth: width ? `${width}px` : "auto",
        maxWidth: width ? `${width}px` : "auto",
      }}
    >
      <div className="panel-icon-heaader-section m-r-5">
        <img
          src={icon ?? ""}
          style={{
            width: "25px",
            height: "25px",
          }}
          className="ic d-flex align-items-center justify-content-center"
          alt=""
        />
      </div>
      <div
        className="panel-color-header-section"
        style={{
          background: "var(--primary)",
          display: "flex",
          alignItems: "center",
          flex: 1, // This makes the colored section expand to fill available space
        }}
      >
        <h4 className="d-flex align-items-center m-l-5" style={{ color: "white" }}>
          <small
            className="font-weight-600"
            style={{
              fontSize: "16px",
              fontFamily: "inter",
              textTransform: "uppercase",
            }}
          >
            {name}
          </small>
        </h4>
      </div>
    </div>
  );
};

export default HeaderSection;
